var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModalClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 55,
    viewBox: "0 0 55 55",
    width: 55,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    fill: "#f8d748",
    r: 26,
    stroke: "#000",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.668 19.668c.2939-.2939.6926-.459 1.1082-.459.4157 0 .8144.1651 1.1083.459l5.543 5.543 5.543-5.543c.2957-.2856.6917-.4436 1.1027-.44.411.0035.8042.1684 1.0948.459.2907.2907.4555.6839.4591 1.0949s-.1544.807-.44 1.1026l-5.543 5.543 5.543 5.543c.2856.2957.4436.6917.44 1.1027s-.1684.8042-.4591 1.0948c-.2906.2907-.6838.4555-1.0948.4591s-.807-.1544-1.1027-.44l-5.543-5.543-5.543 5.543c-.2956.2856-.6916.4436-1.1026.44s-.8042-.1684-1.0949-.4591c-.2906-.2906-.4555-.6838-.459-1.0948-.0036-.411.1544-.807.44-1.1027l5.543-5.543-5.543-5.543c-.2939-.2939-.459-.6926-.459-1.1083 0-.4156.1651-.8143.459-1.1082z",
    fill: "#000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalClose);
export default __webpack_public_path__ + "static/media/modal-close.db705761645628fdb2650a15ca75de50.svg";
export { ForwardRef as ReactComponent };